import { HOUR_IN_SECONDS } from 'core/common/constants/durations';

export const utmTagsCookieMaxAgeSeconds = 5 * HOUR_IN_SECONDS;
